import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Observable, Subscriber } from 'rxjs';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  @ViewChild('fileUploader') fileUploader: ElementRef;
  fileName: string;
  errormessage: string;
  uploadDoc: any;
  fileUploads: any;
  DocView = false;
 CourseList: any = [];
  filteredListCourse: any = [];
  NotifyForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitButton = false;
  AssignTable: [];
  New = true;
  editButton = false;
  deleteButton = false;
  Table = false;
  submitpayload: any;
  inputTimeout: any;
  collegeList: any = [];
  userCoData = []
  filteredCollegeList: any = [];
  LvlArray: FormArray;
  lvl = 0;
  sessionId = 0;
  CoCode = 0;
  filteredRoleList: any;
  RoleList: any;
  userList: any;
  filteredUserList: { [index: number]: any[] } = {};
  errMsg: any;
  sessionList: any;
  SessionFilterList: any;
  AssTable: any;
  AssLvl: FormArray;
  assignTableData: any[];
  arr: any;
  APIService: string;
  notificationCreate=true;
  userPermission: any;
  utp: string;
  UserCollege
  rowsCount: any;
  ReadOnly
  ListTable = false;
  currentSearchQueries: string[] = [];
  NotificationsData: any[];
  ApplicationType: string = '';
  constructor(private dialog: MatDialog,public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,private datePipe: DatePipe,
    public fb: FormBuilder) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    this.ListTable = false;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Publish Notification' && element.PCreate == false)
      {
          this.notificationCreate = false;  
      }
      
    });
  }
    let id = ''
    this.sessionId = 0;
    this.lvl = 0;
    this.arr = [];
    this.CoCode = 0;
    this.submitButton = false;
    this.Table = false;
    this.editButton = false;
    this.deleteButton = false;
    this.NotifyForm = this.fb.group({
      course: new FormControl(''),
      SessionId: new FormControl('',[Validators.required]),   
      NotTitle: new FormControl('',[Validators.required]),
      NotDesc: new FormControl(''),
      ReadStatus: new FormControl(''),
      ApplicationType: new FormControl(''),
      CgCode:new FormControl(''),
      newDocumentArray: this.fb.array([])
    });

    this.fetchSession(id);
    this.addNewRow();
    this.getCollegeData();
  }

 
  getnewDocumentArrayControls() {
    return (this.NotifyForm.get('newDocumentArray') as FormArray).controls;
  }

  addNewRow() {
    const creds2 = this.NotifyForm.controls.newDocumentArray as FormArray;
    creds2.push(
      this.fb.group({
        DocumentName: new FormControl(''),
        docFile: new FormControl(''),
        DocumentFile: new FormControl(''),
       
      })
    );
  }

  addNextRow() {
    const creds2 = this.NotifyForm.controls.newDocumentArray as FormArray;
    creds2.push(
      this.fb.group({
        DocumentName: new FormControl(''),
        docFile: new FormControl(''),
        DocumentFile: new FormControl(''),
       
      })
    );
  }


  deleteRow(index) {
    if (index !== 0) {
      (<FormArray>this.NotifyForm.get('newDocumentArray')).removeAt(index);
      this.arr = this.NotifyForm.controls.newDocumentArray.value;
    } 
    else {
      let length = this.NotifyForm.get('newDocumentArray').value.length;
      if (length > 1) {
        (<FormArray>this.NotifyForm.get('newDocumentArray')).removeAt(index);
        this.arr = this.NotifyForm.controls.newDocumentArray.value;
      } else if (length == 1) {
        let data = {};
        data['message'] = 'First Row Can Not Be Deleted';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    }
  }

  onChange($event: Event, rowIndex: number) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    const faControl = (<FormArray>this.NotifyForm.controls['newDocumentArray']).at(rowIndex);

    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      if (ext === "pdf") {
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(fileName);
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        let data = {
          message: 'Please Upload Only PDF File',
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }


  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      // while (this.fileUploads.length <= rowIndex) {
      //   this.fileUploads.push(null);
      // }
      if (!this.fileUploads) {
        this.fileUploads = [];  // Initialize if it's undefined
      }

      // Check if the rowIndex exists in the array, and if not, create a placeholder
      if (!this.fileUploads[rowIndex]) {
        this.fileUploads[rowIndex] = {}; // Initialize row if it's missing
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.NotifyForm.controls['newDocumentArray']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  showbase64(e) { 
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.DocUpload
      });
  }

  
  fetchSession(id) {
    this.spinner.show()
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getCourse(id){
    this.spinner.show()
    this.Table = false;
    this.CourseList = [];
    this.filteredListCourse = [];
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.sessionId = id
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    payload['SessionId'] = id; 
    this.umsService.fetchIntakeFilter(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.NotifyForm.controls['course'].setValue('');
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }


  submit(){
   
    if (this.NotifyForm.invalid) {
      // this.NotifyForm.get('course').markAsTouched();
      this.NotifyForm.get('SessionId').markAsTouched();
      this.NotifyForm.get('NotTitle').markAsTouched();
      return;
    } else {
       
      this.AddData();
    }
  }

  
  AddData(){
    this.spinner.show();
    this.submitpayload = this.NotifyForm.value;
      let iserror = false;
    if(this.submitpayload.newDocumentArray[0]['DocumentFile'] == ''){
      const payload = {};
      payload['SnNo'] = this.submitpayload.SessionId
      payload['CoCode'] = this.submitpayload.course; 
      payload['NotTitle'] = this.submitpayload.NotTitle; 
      payload['NotDesc'] = this.submitpayload.NotDesc; 
      payload['DocName'] = '' 
      payload['DocUpload'] = ''; 
      payload['SrNo'] = ''; 
      payload['ReadStatus'] = 'N'; 
      payload['CgCode'] = this.submitpayload.CgCode;
      payload['ApplicationType'] = this.submitpayload.ApplicationType;
  
      this.umsService.AddStuNotify(payload).subscribe(res => {
        if(res.status){
          this.spinner.hide();
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.getList();
          });
        }
        else{
          this.spinner.hide();
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.getList();
          });
        }
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.getList();
        });
      })
    }
    else if(this.submitpayload.newDocumentArray[0]['DocumentFile']!= ''){
      var bar = new Promise<void>((resolve, reject) => {
        this.NotifyForm.controls.newDocumentArray.value.forEach((element, index, array) => {
          let srno = index + 1
          let payload = {};
          payload['SnNo'] = this.submitpayload.SessionId
          payload['CoCode'] = this.submitpayload.course; 
          payload['NotTitle'] = this.submitpayload.NotTitle; 
          payload['NotDesc'] = this.submitpayload.NotDesc; 
          payload['DocName'] = element.DocumentName; 
          payload['DocUpload'] = this.fileUploads[index] == undefined ? element.DocumentFile : this.fileUploads[index]; 
          payload['SrNo'] = ''; 
          payload['ReadStatus'] = 'N'; 
          payload['CgCode'] = this.submitpayload.CgCode;
          payload['ApplicationType'] = this.submitpayload.ApplicationType;
         
          setTimeout(() => {
            this.umsService.AddStuNotify(payload).subscribe(res => {
              // this.spinner.hide();
              if (res.status == false) {
                // this.spinner.hide()
                iserror = true;
                this.errMsg = res.message;
              } else {
                // this.spinner.hide()
                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              // this.fetchDocument();
              if(this.fileUploader != undefined){
                this.fileUploader.nativeElement.value = null;
              }
              
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });
  
      })
      bar.then(() => {
        this.spinner.hide();
        if (iserror == false) {
          this.spinner.hide();
          // this.saveApplicationDetails();
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            // this.getList();
            this.ngOnInit();
          });
        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            // this.getList();
            this.ngOnInit();
          });
        }
      });
    }
  
  }

  getList(){
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = this.NotifyForm.value['course'];
    payload['SnNo'] = this.NotifyForm.value['SessionId']; 
    payload['CgCode'] = this.NotifyForm.value['CgCode']; 
    payload['ApplicationType'] = this.NotifyForm.value['ApplicationType']; 
    this.umsService.getStuNotify(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.NotificationsData = res.data;
        this.ListTable = true;
      }
      else{
        this.spinner.hide();
        this.NotificationsData = []
        this.ListTable = false;
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.NotificationsData = []
      this.ListTable = false;
    })
  }

  editData(data){
    this.NotifyForm = this.fb.group({
      course: new FormControl(data.CoCode),
      SessionId: new FormControl(data.SnNo,[Validators.required]),   
      NotTitle: new FormControl(data.NotTitle,[Validators.required]),
      NotDesc: new FormControl(data.NotDesc),
      ReadStatus: new FormControl(data.ReadStatus),
      NotificationId: new FormControl(data.NotificationId),
      ApplicationType: new FormControl(data.ApplicationType),
    });
    // if(data.DocName != '' && data.DocUpload != ''){
    //   data.forEach(element => {
    //     // this.prepopulateNew(element);
    //     const creds = this.NotifyForm.controls.newDocumentArray as FormArray;
    //     creds.push(
    //       this.fb.group({
    //         DocumentName: new FormControl(element.DocName),
    //         docFile: new FormControl(element.DocUpload),
    //         DocumentFile: new FormControl(element.DocUpload),
    //       })
    //     );
    //   });
    // }
  }

  deleteData(data){

  }

  // shouldMergeRows(index: number, field: string): boolean {
  //   if (index === 0) {
  //     return true;  // Always show the first row
  //   }
  //   return this.NotificationsData[index][field] !== this.NotificationsData[index - 1][field];
  // }

  // // Function to get the rowspan for title or description
  // getRowSpan(index: number, field: string): number {
  //   if (index === 0) {
  //     return 1;  // Always show the first row
  //   }

  //   let span = 1;
  //   let currentValue = this.NotificationsData[index][field];

  //   // Calculate rowspan by checking the next rows for the same value
  //   for (let i = index + 1; i < this.NotificationsData.length; i++) {
  //     if (this.NotificationsData[i][field] === currentValue) {
  //       span++;
  //     } else {
  //       break;
  //     }
  //   }
  //   return span;
  // }
 


  shouldMergeRows(index: number, field: string): boolean {
    if (index === 0) {
      return true; // Always show the first row
    }
    return (
      this.NotificationsData[index][field] !==
      this.NotificationsData[index - 1][field]
    );
  }
 
  // Calculates the rowspan for a cell
  getRowSpan(index: number, field: string): number {
    let span = 1;
    const currentValue = this.NotificationsData[index][field];
 
    for (let i = index + 1; i < this.NotificationsData.length; i++) {
      if (this.NotificationsData[i][field] === currentValue) {
        span++;
      } else {
        break;
      }
    }
    return span;
  }
  getCollegeData(){
    let payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

getNitiType(value){
  this.submitButton = true
  if(value == 'Admin'){
    this.ApplicationType = value; // Update the ApplicationType variable
    // You can also update the form control if you prefer CgCode
    this.NotifyForm.get('ApplicationType')?.setValue(value);
    this.getCollegeData();
  }else{
    this.ApplicationType = ''; // Update the ApplicationType variable
    // You can also update the form control if you prefer CgCode
    this.NotifyForm.get('ApplicationType')?.setValue('');

  }
  
}



getList2(data){
  this.spinner.show();
  const payload = {};
  payload['CoCode'] = this.NotifyForm.value['course'];
  payload['SnNo'] = this.NotifyForm.value['SessionId']; 
  payload['CgCode'] = this.NotifyForm.value['CgCode']; 
  payload['ApplicationType'] = data; 
  this.umsService.getStuNotify(payload).subscribe(res => {
    if(res.status){
      this.spinner.hide();
      this.NotificationsData = res.data;
      this.ListTable = true;
    }
    else{
      this.spinner.hide();
      this.NotificationsData = []
      this.ListTable = false;
    }
  },(ERROR: HttpErrorResponse) => {
    this.spinner.hide()
    this.NotificationsData = []
    this.ListTable = false;
  })
}
convertUTCToIST(dateString: string): string {
  const utcDate = new Date(dateString); // Convert string to Date object
  // Directly use the date pipe with 'Asia/Kolkata' time zone
  return this.datePipe.transform(utcDate, 'dd/MM/yyyy', 'Asia/Kolkata') || '';
}

getSrNo(index: number): number {
  let count = 1; // Start with Sr No 1
  for (let i = 0; i < index; i++) {
    if (this.shouldMergeRows(i, 'NotTitle')) {
      count++;
    }
  }
  return count;
}
}
